import { render } from "./CalendarManage.vue?vue&type=template&id=184806c4&scoped=true"
import script from "./CalendarManage.vue?vue&type=script&lang=js"
export * from "./CalendarManage.vue?vue&type=script&lang=js"

import "./CalendarManage.vue?vue&type=style&index=0&id=184806c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184806c4"]])

export default __exports__